import React from "react";
import List from "@mui/material/List";
import MessageItem from "./MessageItem";
import PropTypes from "prop-types";



const MessagesList = ({ notifications }) => {

  let notifyDatas = notifications.filter((opt) => opt?.Open_flg === false)

  const count = 10 - notifyDatas?.length


  if (notifyDatas < 10) {
    notifyDatas = notifyDatas.concat(notifications.slice(0, count));
  }

  return (
    <List disablePadding>
      {notifyDatas?.map((item) => {
        return <MessageItem key={item?.id} item={item} />;
      })}
    </List>
  );
};

MessagesList.propTypes = {
  notifications: PropTypes.array.isRequired,
};

export default MessagesList;
